import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

import type { BasketOptimizerOptimizeResponse } from './basket-optimizer';

interface PersistGraphRequest {
  productSubtype: string;
  pricerRfqId: string;
  tradeDate: string;
  bidPrice?: number;
  askPrice?: number;
  bidCorrelation?: number;
  askCorrelation?: number;
}
export function correlationGraphApi(http: IHttpClient) {
  return {
    persist(request: PersistGraphRequest) {
      return http
        .postJSON<BasketOptimizerOptimizeResponse>({
          url: 'api/v1/correlation-graph',
          body: request,
          targetHost: 'AdvisoryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
